<template>
  <v-container>
    <v-sheet class="pa-7 mb-12">
        <hand-book-guide></hand-book-guide>
        <!-- <div>创作中心 - 帮助</div>
        <v-divider></v-divider>
        <div>基于「一起练琴」创作中心，用户可以上传自己的乐谱。在 App 里「在线乐谱库」里可以下载到自己的上传的乐谱。</div>
        <br>
        <div>
            <span>如何使用「创作中心」，这里有一个</span>
            <span>手把手的图文教程</span>
            <span>。</span>
        </div>
        <div>
            <span>创作中心上传的乐谱，是需要上传 MuseScore 制谱软件生成的文件。使用 MuseScore 打谱有一定的门槛，我们特地为您准备了一个详细的</span>
            <span>视频教程</span>
            <span>。</span>
        </div>
        <div>
            <span>为了 MuseScore 打谱的结果更好地在「一起练琴」App 里使用，我们有一些</span>
            <span>录谱规范的要求</span>
            <span>。</span>
        </div>
        <div>
            <span>很有可能，您是不会自己打谱的，毕竟学习制谱门槛相当高。为此，我们给您推荐下述第三方独立录谱人员。这些录谱人员也曾经帮我们录制乐谱，他们熟悉</span>
            <span>我们的乐谱规范</span>
            <span>。</span>
        </div>
        <ul>
            <li>冯老师：13129170017（微信同号）</li>
            <li>甘老师：18018910973（微信同号）</li>
            <li>钟老师：13479902065（微信同号）</li>
        </ul>
        <div>基于我们合作时的录谱价格，我们建议如下：</div> -->

    </v-sheet>
  </v-container>
</template>

<script>
import HandBookGuide from "./HandBookGuide";
import HandBookMusescore from "./HandBookMusescore";

export default {
  name: "HandBook",
  data: function() {
    return {
      tabList: [
        {
          title: "使用指南",
          subtitle: "创作中心，乐曲上传图文流程"
        },
        {
          title: "指导视频",
          subtitle: "创作中心使用视频教程"
        },
        {
          title: "录谱教程",
          subtitle: "如何自己录制乐谱文件"
        },
        {
          title: "其他录谱渠道",
          subtitle: "一起练琴推荐的第三方录谱渠道"
        }
      ]
    };
  },
  components: {
    handBookGuide: HandBookGuide,
    handBookMusescore: HandBookMusescore
  },
};
</script>

<style scoped>
.left-list {
  border-style: solid;
  /* border-color: red; */
  border-color: #f4f4f4;
  border-width: 0px;
  border-right-width: 1px;

  padding-right: 2px;
}

.active-tab-item {
  background-color: #f9fafc;
}

.tab-title {
  font-size: 20px;
  font-weight: 900;
}
.tab-item {
  text-align: left;
  width: 250px;
}
</style>
